const contentChannel = () => import('@/pages/content/channel/index.vue');

export default [{
    path: '/content/channel',
    component: contentChannel,
    meta: [{
        name: '内容管理',
		activeRoute: '/content/manage'
    },
    {
        name: '购买渠道',
        activeRoute: '/content/channel'
    }]
}];